import axios from 'axios';

import { FaqPageDto, FaqResponseDto } from './types';

export const faqApi = {
  get(): Promise<FaqPageDto[]> {
    return axios
      .get<FaqResponseDto>(`${import.meta.env.VITE_GITBOOK_SPACE_URL}/content`)
      .then(({ data }) => data.pages);
  },
};
